//@flow
import memoize from 'memoizee';
import FunctionStore from '../Base/functionStoreClass';
import { updateState, getFlagProp, setFlagProp } from '../Base/storeUtils';
import Constants from '../../constants';
import _ from 'underscore';
import FilterData from './filtersData';
import { Map, OrderedMap } from 'immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export type TasteFilter = $Keys<typeof FilterData.TASTE>;
export type StandardFilter = $Keys<typeof FilterData.NUTRITION>;
export type FilterKey = TasteFilter|StandardFilter;

export type Filter = { name:FilterKey, text:string };
export type FilterMapping = {[FilterKey]:string};
export type FilterCategories = {
  NUTRITION:FilterMapping,
  TASTE:FilterMapping,
};

const filterMappings = _.extend({}, ..._.values(FilterData) );

const _mapSelectedFilters = memoize((filterMap:Map<FilterKey, boolean>) => {
  const filters:FilterKey[] = (filterMap.keySeq().toJS().reverse():any);
  return _.map(filters, filter => ({ name: filter, text: filterMappings[filter] }));
});

export default class FiltersStore extends FunctionStore {
  _initialState(state:StoreState) {
    state.set('filters', OrderedMap());
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.CLEAR_FILTERS, updateState(_clearFilters));
    onSuccess(Constants.ADD_FILTER, updateState(_addFilter));
    onSuccess(Constants.REMOVE_FILTER, updateState(_removeFilter));
    onSuccess(Constants.TOGGLE_FILTER, updateState(_toggleFilter));
    onSuccess(Constants.TOGGLE_MOBILE_FILTERS, updateState(_toggleMobileFilters));
  }

  getFilterCategories():FilterCategories {
    return FilterData;
  }

  getFilterMappings():FilterMapping {
    return filterMappings;
  }

  getSelectedFilters():Filter[] {
    return _mapSelectedFilters(this.getState().get('filters', Map()));
  }

  getMobileFiltersOpen() {
    return this._getFlag('mobileFiltersOpen');
  }
}

function _toggleMobileFilters(state:StoreState) {
  setFlagProp(state, 'mobileFiltersOpen', getFlagProp(state, 'mobileFiltersOpen'));
}

const _clearFilters = (state:StoreState) => state.delete('filters');

function _removeFilter(state:StoreState, data:{ name:string }) {
  state.deleteIn(['filters', data.name]);
}

function _addFilter(state:StoreState, data:{ name:string }) {
  state.setIn(['filters', data.name], true);
}

function _inCollection(state:StoreState, data:{ name:string }) {
  return state.hasIn(['filters', data.name]);
}

function _toggleFilter(state:StoreState, data:{ name:string }) {
  if (_inCollection(state, data)) {
    _removeFilter(state, data);
  } else {
    _addFilter(state, data);
  }
}
